import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";

export default function SignupWizardConfirmation(props) {
  if (props.state.wizardStep !== "confirmation") {
    return null;
  } else {
    window.onbeforeunload = null;
  }
  return (
    <div className="App confirmationBG">
      <Header />
      <Confirmation currentState={props.state} />
      <Footer confirmation={true} />
    </div>
  );
}

const Confirmation = (props) => {
  const { width, height } = useWindowSize();
  const recycle = false;
  return (
    <div id="about" className="section wide img light confirmation">
      <Confetti width={width} height={height} recycle={recycle} style={{ zIndex: "9999999" }} />
      <div className="wrap confirmation">
        <h2 className="heading-4 confirm">
          You’re all set{" "}
          {props.currentState.caregiverFlow ? props.currentState.caregiverFirstName : props.currentState.firstName}!
          <br />
        </h2>
        <div className="confirmationcontainer w-container">
          <h2
            className="paragraph-2 confirmation"
            style={{ display: !props.currentState.caregiverFlow ? "block" : "none" }}
          >
            Thanks for signing up with Duos. We can’t wait to support your independence.
            <br />
          </h2>
          <h2
            className="paragraph-2 confirmation"
            style={{ display: !props.currentState.caregiverFlow ? "none" : "block" }}
          >
            Thanks for signing your loved one up with Duos. We can’t wait to support their independence.
            <br />
          </h2>
          <h2 className="paragraph-2 orange">
            What comes next?
            <br />
          </h2>
          <h2 className="paragraph-2 confirmation">
            1<br />
            We’ll review your application and reach out within the next business day.
            <br />
          </h2>
          <h2
            className="paragraph-2 confirmation"
            style={{ display: !props.currentState.caregiverFlow ? "block" : "none" }}
          >
            2<br />
            We’ll match you with a Duo that fits your specific needs and personality.
            <br />
          </h2>
          <h2
            className="paragraph-2 confirmation"
            style={{ display: !props.currentState.caregiverFlow ? "none" : "block" }}
          >
            2<br />
            We’ll match your loved one with a Duo that fits their specific needs and personality.
            <br />
          </h2>
        </div>
        <a href="https://www.getduos.com/welcome" className="button-hero sub w-button">
          Back to DUOS
        </a>
      </div>
    </div>
  );
};
